import { BaseEntity } from 'src/app/tools/models/baseEntity';

export class Bank extends BaseEntity {

  bankCode  : string;
  name      : string;


  bic: string;
  constructor() {
    super();

  }
}